export class ActivityTypeModel {
  constructor ({
    id,
    name,
  }) {
    this.id = id
    this.name = name
  }
}



// WEBPACK FOOTER //
// ./src/server/modules/activities/ActivityTypeModel.js